var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconHelpWhatsnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#bdccd4;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-help-whatsnew") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.33,0c-.14,0-.36,1.32-.46,1.44s-1.44.26-1.46.41,1.15.77,1.22.91-.19,1.44,0,1.51,1.08-.86,1.22-.89,1.32.62,1.41.5-.48-1.29-.46-1.44,1-1.05.93-1.2-1.39.07-1.51,0S22.5,0,22.33,0ZM12.77,3.16c-.46,0-2.87,3.07-3.31,3.21s-4.22-.91-4.58-.65S4.37,9.9,4.1,10.28.15,12,0,12.44s2,3.69,2,4.15S-.14,20.3,0,20.73s3.81,1.8,4.1,2.18.41,4.27.79,4.53,4.12-.79,4.58-.65S12.32,30,12.77,30s2.87-3.07,3.33-3.21,4.19.93,4.55.65.53-4.17.81-4.53,3.93-1.73,4.07-2.18-2-3.69-2-4.15,2.18-3.71,2-4.15-3.81-1.8-4.07-2.16S21,6,20.66,5.73s-4.12.79-4.55.65S13.23,3.16,12.77,3.16Zm15,.36c-.38.09-1.87,1.61-2.14,1.65S23.2,4.1,23,4.29s.93,2.32.89,2.59-1.77,2-1.65,2.2,2.51-.17,2.75,0,1.32,2.28,1.58,2.23.62-2.42.81-2.61S30,8.12,30,7.86s-2.11-1.34-2.23-1.58.26-2.64,0-2.76Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHelpWhatsnew);
export default __webpack_public_path__ + "static/media/icon-help-whatsnew.e71ddb7d484ff75f1c2cfbe94938a7aa.svg";
export { ForwardRef as ReactComponent };